import FeatureSectionFour, { FeatureSectionFourProps } from './FeatureSectionFour'

export default FeatureSectionFour

export { FeatureSectionFour }
export type { FeatureSectionFourProps }
